import { render, staticRenderFns } from "./template.html?vue&type=template&id=32868b03&scoped=true&external"
import script from "./choose-product.vue?vue&type=script&lang=js"
export * from "./choose-product.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=32868b03&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32868b03",
  null
  
)

export default component.exports